/**
 * Sanitização de HTML para prevenir XSS ao usar dangerouslySetInnerHTML.
 * Remove scripts, event handlers e URIs perigosos (javascript:).
 * Use para conteúdo de notícias e guias vindos da API.
 */

const SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
const ON_EVENT_REGEX = /\s on\w+\s*=\s*["'][^"']*["']/gi;
const ON_EVENT_REGEX2 = /\s on\w+\s*=\s*[^\s>]*/gi;
const JAVASCRIPT_URL_REGEX = /javascript\s*:/gi;
const DATA_URL_REGEX = /data\s*:\s*[^"'\s]*/gi;

/**
 * Remove conteúdo perigoso do HTML (scripts, handlers, javascript:).
 * Permite tags comuns de formato (p, strong, em, a, ul, li, etc.).
 */
export function sanitizeHtml(html) {
  if (html == null || typeof html !== 'string') return '';
  let out = html
    .replace(SCRIPT_REGEX, '')
    .replace(ON_EVENT_REGEX, '')
    .replace(ON_EVENT_REGEX2, '')
    .replace(JAVASCRIPT_URL_REGEX, '')
    .replace(DATA_URL_REGEX, '');
  return out;
}
